import {useTranslation} from 'react-i18next'

import {NewScreenHeader as ScreenHeader} from '~/react/components/ScreenHeader'

function NotFoundScreen() {
  const {t} = useTranslation()

  return <ScreenHeader text={t('notFound')} />
}

export default NotFoundScreen
